export enum LampStatus {
  OFFLINE = 0,
  FAIL_DOWN = 1,
  ONLINE = 2,
  FAIL_UP = 3,
}
